import { KeyStatsComponent } from "./key-stats"
import { PerformanceComponent } from "./performance"
import { ReportingComponent } from "./reporting"
import { TrainingComponent } from "./training"
import { FeedbackComponent } from "./feedback"

export default {
  KeyStatsComponent,
  PerformanceComponent,
  ReportingComponent,
  TrainingComponent,
  FeedbackComponent,
}
